/**
 * MODULE: platform/browser/frontend/utils/browserSessionStatusLabel.ts
 * PURPOSE: Format session status label for chat panel and viewport toolbar.
 * DEPENDENCIES: none
 * PUBLIC_API: formatBrowserSessionStatusLabel
 * SIDE_EFFECTS: none
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-06-17 [2.2.1407] — Live status suffix with server/local action count.
 */

export function formatBrowserSessionStatusLabel(options: {
  sessionExpired: boolean;
  hasSession: boolean;
  isConnecting: boolean;
  actionCount?: number;
  provider?: 'steel' | 'browserbase' | 'unknown';
  steelProxied?: boolean;
}): string {
  const { sessionExpired, hasSession, isConnecting, actionCount, provider, steelProxied } = options;

  let base: string;
  if (sessionExpired) {
    base = 'Session ended';
  } else if (hasSession) {
    base = 'Live';
  } else if (isConnecting) {
    base = 'Connecting…';
  } else {
    base = 'Idle';
  }

  const providerSuffix =
    provider === 'steel'
      ? steelProxied
        ? ' · Steel local'
        : ' · Steel'
      : provider === 'browserbase'
        ? ' · Cloud'
        : '';

  if (!hasSession || sessionExpired || actionCount == null || actionCount <= 0) {
    return `${base}${providerSuffix}`;
  }

  const noun = actionCount === 1 ? 'action' : 'actions';
  return `${base} · ${actionCount} ${noun}${providerSuffix}`;
}
